// Property Source browser-extension sync.
//
// The extension has no auth and can't read Firestore, so it can't know which
// listings you've already imported (or their status). This module closes that
// gap: while the app is open with a session (guest counts — it's the same
// browser), it broadcasts the property list (source_url → property_id + status)
// via window.postMessage, and the extension's content script on this origin
// picks it up and keys its overlay buttons by it. Nothing leaves the page; the
// extension just listens.
//
// Broadcast on every snapshot change AND on a 5s interval — the interval
// covers the case where the extension's content script registers after this
// module ran (e.g. the extension was reloaded). Silent when signed out: an
// empty broadcast during a transient auth-restore gap would wipe the
// extension's local state.
import { auth, onAuthStateChanged } from './firebase.js';
import { watchMyProperties } from './firestore.js';

const BROADCAST_MS = 5000;
const MESSAGE_TYPE = 'property-sauce:list';

let unsubscribe = null;
let timer = null;
let lastProps = [];
let lastJson = null;

function broadcast(uid, props) {
  const urls = {};
  const statuses = {};
  for (const p of props) {
    if (p.source_url) {
      urls[p.source_url] = p.id;
      statuses[p.source_url] = p.status;
    }
  }
  const payload = { type: MESSAGE_TYPE, uid, urls, statuses };
  const json = JSON.stringify(payload);
  if (json === lastJson) return; // unchanged — don't spam the page
  lastJson = json;
  window.postMessage(payload, '*');
}

onAuthStateChanged(auth, (user) => {
  if (unsubscribe) {
    unsubscribe();
    unsubscribe = null;
  }
  clearInterval(timer);
  timer = null;
  lastProps = [];
  lastJson = null;
  if (!user) return; // signed out — stay silent

  unsubscribe = watchMyProperties(user.uid, (props) => {
    lastProps = props;
    broadcast(user.uid, props);
  });
  // Re-broadcast the latest snapshot on an interval in case the extension's
  // content script (re)loaded after the last snapshot fired.
  timer = setInterval(() => {
    if (lastProps.length) broadcast(user.uid, lastProps);
  }, BROADCAST_MS);
});
